﻿import {Core} from "../../Base/Core";
import {UIGameObject} from "../Tools/Base/UIGameObject";
import {UIText} from "../Tools/Base/UIText";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {BoosterType} from "../../enums";
import {NUtils} from "../../Utils/NUtils";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UISprite} from "../Tools/Base/UISprite";
import {RewardedAdsBtn} from "../RewardedAdsBtn";

export class UICoinsBooster extends UICommonPopup {
    Awake() {
        super.Awake({
            title: Core.Localizator.Get("bonus_gold_title"),
            closeButton: true,
        });

        this.onWatched = this.onWatched.bind(this);

        this.objectX2 = this.content.addChild(new UIGameObject()); // GameObject objectX2;
        this.objectX4 = this.content.addChild(new UIGameObject()); // GameObject objectX4;

        this.iconBack = this.content.addChild(new UINineSlice("bg-simple"));
        this.iconBack.tint = 0x000000;
        this.iconBack.alpha = 0.3;

        this.iconImage = this.content.addChild(new UISprite("bank/pack-gold-mountain"));

        this.clockBack = this.content.addChild(new UINineSlice("bg-simple"));
        this.clockBack.tint = 0x000000;
        this.clockBack.alpha = 0.3;

        this.clock = this.content.addChild(new UISprite("ico-clock"));

        this.multiplier = this.content.addChild(new UIText());

        this.buttonTake = this.content.addChild(
            new RewardedAdsBtn("btn-green", {
                label: Core.Localizator.Get("take").toUpperCase(),
                icon: "play-icon",
                iconAlign: "right",
                iconSize: 0.7,
            })
        );
        this.timeTextField = this.content.addChild(new UIText()); // Text timeTextField;
        this.timeNumbersField = this.content.addChild(new UIText("", {fitTextTemplate: "00h 00m 00s"})); // Text timeNumbersField;
        this.descField = this.content.addChild(new UIText()); // Text descField;

        this.buttonTake.on("pointertap", () => {
            Core.Ads.TriggerRewarded(this.onWatched);
        });
    }

    onWatched() {
        let incomeTimerX2 = Core.Player.Timers.GetTimerById(Core.Player.Timers.incomeBoosterTimerId);
        let isX2IncomeActive = incomeTimerX2 && !incomeTimerX2.IsFinished;
        let incomeTimerX4 = Core.Player.Timers.GetTimerById(Core.Player.Timers.incomeX4BoosterTimerId);
        let isX4IncomeActive = incomeTimerX4 && !incomeTimerX4.IsFinished;

        if (isX2IncomeActive) {
            Core.Player.Timers.l4b = Core.Time.DayUniqId;
            Core.Boosters.AddBoosterTime(BoosterType.IncomeX4, Core.GameData.Gameplay.incomeX4Seconds);
        } else {
            Core.Player.Timers.l2b = Core.Time.DayUniqId;
            Core.Boosters.AddBoosterTime(BoosterType.Income, Core.GameData.Gameplay.incomeX2Seconds);
        }
        this.Hide();
    }

    Show() {
        let incomeTimerX2 = Core.Player.Timers.GetTimerById(Core.Player.Timers.incomeBoosterTimerId);
        let isX2IncomeActive = incomeTimerX2 && !incomeTimerX2.IsFinished;
        let incomeTimerX4 = Core.Player.Timers.GetTimerById(Core.Player.Timers.incomeX4BoosterTimerId);
        let isX4IncomeActive = incomeTimerX4 && !incomeTimerX4.IsFinished;

        if (isX4IncomeActive) return; // this popup should not be opened when x4 is active

        this.objectX2.SetActive(!isX2IncomeActive);
        this.objectX4.SetActive(isX2IncomeActive);

        if (isX2IncomeActive) {
            this.timeNumbersField.text = NUtils.FormatSecondsToTime(Core.GameData.Gameplay.incomeX4Seconds);
            this.timeTextField.text = Core.Localizator.Get("for_n_minutes", Math.floor(Core.GameData.Gameplay.incomeX4Seconds / 60));
            this.descField.text = Core.Localizator.Get("bonus_gold_desc_х4");
            this.multiplier.text = "x4";
        } else {
            this.timeNumbersField.text = NUtils.FormatSecondsToTime(Core.GameData.Gameplay.incomeX2Seconds);
            this.timeTextField.text = Core.Localizator.Get("for_n_hours", Math.floor(Core.GameData.Gameplay.incomeX2Seconds / 60 / 60));
            this.descField.text = Core.Localizator.Get("bonus_gold_desc");
            this.multiplier.text = "x2";
        }
        super.Show();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.35;
        let w = Math.min(viewport.width * 0.7, (viewport.height * 0.7) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize(true);

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.12;
        rect.width = popupRect.width * 0.42;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = popupRect.y + (popupRect.height - rect.height) * 0.02;
        this.descField.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.6;
        rect.width = popupRect.width * 0.75;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = popupRect.y + (popupRect.height - rect.height) * 0.38;
        this.iconBack.fitLayout(rect);

        let iconBackRect = new PIXI.Rectangle(this.iconBack.x, this.iconBack.y, this.iconBack.width, this.iconBack.height);
        rect = iconBackRect.clone();
        rect.height = iconBackRect.height * 0.62;
        rect.width = iconBackRect.width * 0.65;
        rect.x = iconBackRect.x + (iconBackRect.width - rect.width) * 0.5;
        rect.y = iconBackRect.y + (iconBackRect.height - rect.height) * 0;
        this.iconImage.fitRect(rect);

        rect = iconBackRect.clone();
        rect.height = iconBackRect.height * 0.25;
        rect.width = iconBackRect.height * 0.25;
        rect.x = this.iconImage.x + (this.iconImage.width - rect.width) * 0.5;
        rect.y = iconBackRect.y + (iconBackRect.height - rect.height) * 0.5;
        this.multiplier.fitLayout(rect);

        rect = iconBackRect.clone();
        rect.height = iconBackRect.height * 0.09;
        rect.width = iconBackRect.width * 0.6;
        rect.x = iconBackRect.x + (iconBackRect.width - rect.width) * 0.5;
        rect.y = iconBackRect.y + (iconBackRect.height - rect.height) * 0.75;
        this.timeTextField.fitLayout(rect);

        let clockRect = new PIXI.Rectangle();
        clockRect.width = iconBackRect.width * 0.4;
        clockRect.height = iconBackRect.height * 0.13;
        clockRect.x = iconBackRect.x + (iconBackRect.width - clockRect.width) * 0.5;
        clockRect.y = iconBackRect.y + (iconBackRect.height - clockRect.height) * 0.89;

        rect = clockRect.clone();
        rect.height = clockRect.height;
        rect.width = clockRect.height;
        rect.x = clockRect.x + (clockRect.width - rect.width) * 0;
        rect.y = clockRect.y + (clockRect.height - rect.height) * 0.5;
        this.clock.fitRect(rect);

        rect = clockRect.clone();
        rect.height = clockRect.height * 0.8;
        rect.width = clockRect.width - this.clock.width * 0.5;
        rect.x = clockRect.x + (clockRect.width - rect.width) * 1;
        rect.y = clockRect.y + (clockRect.height - rect.height) * 0.5;
        this.clockBack.fitLayout(rect);

        rect = clockRect.clone();
        rect.height = clockRect.height * 0.6;
        rect.width = clockRect.width - this.clock.width * 1.3;
        rect.x = clockRect.x + (clockRect.width - rect.width) * 1;
        rect.y = clockRect.y + (clockRect.height - rect.height) * 0.5;
        this.timeNumbersField.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.14;
        rect.width = popupRect.width * 0.6;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = popupRect.y + (popupRect.height - rect.height) * 0.95;
        this.buttonTake.fitLayout(rect);
    }
}
